const Flickity = require('flickity');
import GLightbox from 'glightbox';
require('flickity-fullscreen');
require('flickity-imagesloaded');

export default () => {

    const sliders = document.querySelectorAll('[data-gallery-slider]');
    for (const slider of sliders) {
        const flkty = new Flickity(slider, {
            cellAlign: 'left',
            imagesLoaded: true,
            freeScroll: true,
            freeScrollFriction: 0.03,
            pageDots: slider.children.length <= 10,
            prevNextButtons: true // slider.children.length > 10
        });
    }

    const images = document.querySelectorAll('[data-gallery-popup]');
    if (images.length) {
        GLightbox({
            selector: '[data-gallery-popup]',
        });
    }

}
